import Breadcrumb from 'semantic-ui-react/dist/commonjs/collections/Breadcrumb';
import '@purple/semantic-ui-purple-theme/components/breadcrumb.css';

export default Breadcrumb;
